const defaultState = {
  windowLevelData: {
    1: { description: 'Soft tissue', window: '400',  level: '40'   },
    2: { description: 'Lung',        window: '1500', level: '-600' },
    3: { description: 'Brain',       window: '150',  level: '90'   },
    4: { description: 'Bone',        window: '2500', level: '480'  },
    5: { description: 'Soft',        window: '80',   level: '40'   },
    6: { description: 'Liver',       window: '40',   level: '40'   },
    7: { description: '', window: '', level: '' },
    8: { description: '', window: '', level: '' },
    9: { description: '', window: '', level: '' },
    10: { description: '', window: '', level: '' },
  },
  generalPreferences: {
    // language: 'en-US'
  },
};

const preferences = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_USER_PREFERENCES': {
      return Object.assign({}, state, action.state);
    }
    default:
      return state;
  }
};

export { defaultState };
export default preferences;
